import sectionApi,{SectionPostParams} from '../../services/sectionApi';
import React, { useState, useEffect  } from 'react';
import PageLoader from "../../components/custom/PageLoader";
import { getPlainTextSummary } from "../../utils/HtmlHelper";

interface Section {
  id: string;
  sectionName: string;
  sectionOrder: number | null;
  isDefault: boolean;
  createdAt: Date;
  subSectionResponses: SubSectionResponse[];
}

interface SubSectionResponse {
  id: string;
  sectionID: string;
  name: string;
  fileUrl: string;
  fileName: string;
  description: string;
  createdAt: string;
}

interface SectionHeaderTextInfo {
  image: string;
  header: string;
  text: string;
}

interface SectionData {
  sectionHeading: string;
  sectionTextHeaderInfoArr: SectionHeaderTextInfo[];
  seeMore: boolean;
}


const sectionTitleImageMap: { [key: string]: string } = {
  "Magazine": "/images/MobileMagazine.png",
  "RegionYukon": "/images/MobileRegionYukon.png",
  "RegionAlaska": "/images/MobileRegionAlaska.png",
  "RegionBritishColumbia": "/images/MobileRegionBritishColumbia.png",
  "Direction1": "/images/MobileDirection1.jpg",
  "Direction2": "/images/MobileDirection2.png",
  "TravelStory1": "/images/MobileTravel1.jpg",
  "TravelStory2": "/images/MobileTravel2.jpg",
  "Support Us": "/images/MobileSupportUs.png",
};

const fallbackImage = "/images/MobileDefault.jpg";

export const SectionMobilePreviewPage: React.FC = () => {
    const [items, setItems] = useState<Section[]>([]);
    const [isPageLoading, setIsPageLoading] = useState<boolean>(true);
  
    useEffect(() => {
      const fetchData = async () => {
        try {
          await getSectionItems();
        } catch (err) {
          console.error("Failed to load data:", err);
        } finally {
          setIsPageLoading(false);
        }
      };
      fetchData();
    }, []);

    const getSectionItems = async () => {
    try {
      const sectionWithRawDate = await sectionApi.getSection();

      const sortedItems = sectionWithRawDate.sort((a: Item, b: Item) => 
            a.sectionOrder - b.sectionOrder);
      /*
      const sectionItems: Section[] = sectionWithRawDate.map((item: any) => ({
        ...item,
        createdAt: new Date(item.createdAt),
      }));

      const sortedItems = sectionItems.sort((a: Item, b: Item) => {
        const aHasOrder = a.sectionOrder !== null && a.sectionOrder !== undefined;
        const bHasOrder = b.sectionOrder !== null && b.sectionOrder !== undefined;

        // Case 1: Both have null sectionOrder - sort by createdAt DESC
        if (!aHasOrder && !bHasOrder) {
          return b.createdAt.getTime() - a.createdAt.getTime();
        }

        // Case 2: Only one has null - null comes first
        if (!aHasOrder && bHasOrder) return -1;
        if (aHasOrder && !bHasOrder) return 1;

        // Case 3: Both have sectionOrder - sort by sectionOrder ASC
        return (a.sectionOrder ?? 0) - (b.sectionOrder ?? 0);
      });
      */

      setItems(sortedItems);
      
    } catch (error) {
      console.error("Error loading items:", error);
    }
  };
  
  return (
    <div style={styles.frame}>
      {/* Notch */}
      <div style={styles.notch}>
        <div style={styles.speaker}></div>
        <div style={styles.camera}></div>
      </div>

      {isPageLoading && <PageLoader />}

      {/* Scrollable container – includes top + white area */}
      <div style={styles.scrollableArea} className="mobile-scroll">
        {/* Top colored area */}
        <div style={styles.topArea}>
          <div style={styles.topRow}>
            <span style={styles.hamburger}>☰</span>
          </div>
          <div style={styles.logoWrapper}>
            <img src="/images/MobileORLogo.png" alt="App Logo" style={styles.appLogo} />
          </div>
        </div>

        {/* White content area */}
        <div style={styles.screen}>
          <span style={styles.closeIcon}>✕</span>

          {items.map((item) => {
            const title = item.sectionName || "";
            const imagePath = sectionTitleImageMap[title] || fallbackImage;

            // Case 1: Default image from map
            if (item.isDefault) {
              const imagePath = sectionTitleImageMap[title] || fallbackImage;

              if (title === "Magazine") {
                return (
                  <div key={item.id} style={{ ...styles.sectionBlock, display: "flex", alignItems: "flex-start" }}>
                    {/* Left half - Image */}
                    <div style={{ flex: 1 }}>
                      <img
                        src={imagePath}
                        alt={title}
                        style={{
                          width: "100%",
                          height: "auto",
                          borderRadius: "8px",
                          objectFit: "cover",
                          display: "block",
                        }}
                      />
                    </div>

                    {/* Right half - Text box */}
                    <div
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        paddingLeft: "10px",
                        gap: "6px", // vertical spacing between lines
                      }}
                    >
                      <div style={{ fontSize: "11px", color: "#000" }}>Check out the</div>

                      <div style={{ fontSize: "13px", fontWeight: "bold", color: "#9D7348" }}>
                        Alaska Highway
                      </div>
                      <div style={{ fontSize: "9px", color: "#999", lineHeight: "1.3" }}>
                        Premier magazine for travel enthusiasts eager to uncover the breathtaking beauty of Alaska Highway.
                      </div>
                      <div style={{ fontSize: "10px", fontWeight: "650", color: "#447B7E" }}>See More</div>
                    </div>
                  </div>
                );
              }

              if (title === "Support Us") {

                return (
                  <div key={item.id} style={{ ...styles.sectionBlock, display: "flex", alignItems: "center" }}>
                    {/* Left half - Image */}
                    <div style={{ flex: 1 }}>
                      <img
                        src={imagePath}
                        alt={title}
                        style={{
                          width: "100%",
                          height: "auto",
                          borderRadius: "8px",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                  </div>
                );
              }

              let SectionDataInfo: SectionData = {
                sectionHeading: "",
                sectionTextHeaderInfoArr: [],
              };

              switch (title) {
                case "Region":
                  SectionDataInfo = {
                    sectionHeading: "Regional Section",
                    seeMore: false,
                    sectionTextHeaderInfoArr: [
                      {
                        image: sectionTitleImageMap["RegionYukon"] || fallbackImage,
                        header: "Yukon",
                        text: "The Yukon is a land of extremes, where vast street...",
                      },
                      {
                        image: sectionTitleImageMap["RegionAlaska"] || fallbackImage,
                        header: "Alaska",
                        text: "Alaska's landscape is a testament to the raw power...",
                      },
                      {
                        image: sectionTitleImageMap["RegionBritishColumbia"] || fallbackImage,
                        header: "British Columbia",
                        text: "Nestled in the embrace of the Pacific Northwest, Bri...",
                      },
                    ],
                  };
                  break;
                case "Travel Story":
                  SectionDataInfo = {
                    sectionHeading: "Travel Stories",
                    seeMore: false,
                    sectionTextHeaderInfoArr: [
                      {
                        image: sectionTitleImageMap["TravelStory1"] || fallbackImage,
                        header: "This place is massive!...",
                        text: "Happy Camper | 06-17-2025",
                      },
                      {
                        image: sectionTitleImageMap["TravelStory2"] || fallbackImage,
                        header: "My travel story",
                        text: "Mayank Joshi | 05-16=2025",
                      },
                    ],
                  };
                  break;
                case "Direction":
                  SectionDataInfo = {
                    sectionHeading: "Directional Section",
                    seeMore: true,
                    sectionTextHeaderInfoArr: [
                      {
                        image: sectionTitleImageMap["Direction1"] || fallbackImage,
                        header: "Northwest",
                        text: "Explore the legendary Alaska Highway from British...",
                      },
                      {
                        image: sectionTitleImageMap["Direction2"] || fallbackImage,
                        header: "Southeast",
                        text: "From Delta Junction in Alaska through the Yukon and back...",
                      },
                    ],
                  };
                  break;
              }

              return (
                <div key={item.id} style={{ ...styles.sectionBlock }}>
                  {/* Label above all images */}
                  <div
                    style={{
                      fontSize: "11px",
                      color: "#000",
                      textAlign: "left",
                      marginBottom: "8px",
                      fontWeight: "450",
                    }}
                  >
                    {SectionDataInfo.sectionHeading}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "10px",
                    }}
                  >
                    {SectionDataInfo.sectionTextHeaderInfoArr.map((headerInfo, index) => (
                      <div key={index} style={{ flex: 1, textAlign: "center" }}>
                        <img
                          src={headerInfo.image}
                          alt={headerInfo.header}
                          style={{
                            width: "100%",
                            height: "auto",
                            borderRadius: "8px",
                            objectFit: "cover",
                            marginBottom: "5px",
                          }}
                        />
                        <div
                          style={{
                            fontSize: "9px",
                            fontWeight: "400",
                            color: "#9D7348",
                            marginBottom: "3px",
                            textAlign: "left",
                          }}
                        >
                          {headerInfo.header}
                        </div>
                        <div style={{ fontSize: "7px", color: "#666", lineHeight: "1.3", textAlign: "left", }}>
                          {headerInfo.text}
                        </div>
                        {(SectionDataInfo.seeMore && (
                        <div style={{ fontSize: "10px", fontWeight: "600", color: "#447B7E", textAlign: "left",  marginTop: "5px", }}>
                          See more
                        </div>
                        )
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              );
            }

            // Case 2/3: From subSectionResponses
            const subs = item.subSectionResponses || [];
            if (subs.length === 1) {
              return (
                <div key={item.id} style={styles.sectionBlock}>
                  <div style={styles.groupTitle}>{title}</div>
                  <img
                    src={subs[0].fileUrl}
                    alt={subs[0].name}
                    style={styles.fullWidthImage}
                  />
                  <div style={{ fontSize: "7px", color: "#666", lineHeight: "1.3", textAlign: "left" }}>
                    {(() => {
                      const plainText = getPlainTextSummary(subs[0].description);
                      return plainText.length > 30 ? `${plainText.substring(0, 30)}...` : plainText;
                    })()}
                  </div>
                </div>
              );
            }

            if (subs.length === 2) {
              return (
                <div key={item.id} style={styles.sectionBlock}>
                  <div style={styles.groupTitle}>{title}</div>
                  <div style={styles.twoImageRow}>
                    {subs.map((sub) => {
                      const plainText = getPlainTextSummary(sub.description);
                      const shortText =
                        plainText.length > 30 ? `${plainText.substring(0, 20)}...` : plainText;
                      return (
                        <div key={sub.id} style={styles.imageWrapper}>
                          <img
                            key={sub.id}
                            src={sub.fileUrl}
                            alt={sub.name}
                            style={styles.halfImage}
                          />
                          <div style={styles.descriptionText}>{shortText}</div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            }

            if (subs.length >= 3) {
              return (
                <div key={item.id} style={styles.sectionBlock}>
                  <div style={styles.groupTitle}>{title}</div>
                  <div
                    style={{
                      ...styles.scrollableRow,
                      overflowX: subs.length > 2 ? "auto" : "visible",
                      flexWrap: "nowrap",
                    }}
                  >
                    {subs.map((sub) => {
                        const plainText = getPlainTextSummary(sub.description);
                        const shortText =
                          plainText.length > 30 ? `${plainText.substring(0, 20)}...` : plainText;
                      return (  
                        <div key={sub.id}
                          style={{
                            ...styles.imageWrapper,
                            flex: subs.length > 2 ? "0 0 40%" : "1 1 46%", // 2 full + half image visible
                          }}
                        >
                          <img
                            key={sub.id}
                            src={sub.fileUrl}
                            alt={sub.name}
                            style={styles.smallImage}
                          />
                        <div style={styles.descriptionText}>{shortText}</div>
                      </div>
                      );
                      })}
                      {subs.length > 2 && <span style={styles.moreIcon}>›</span>}
                  </div>
                </div>
              );
            }

            return null;
          })}
        </div>
      </div>

      {/* Hide scrollbar (WebKit) */}
      <style>
        {`
          .mobile-scroll::-webkit-scrollbar {
            display: none;
          }
        `}
      </style>
    </div>
  );
};

export default SectionMobilePreviewPage;

const styles: { [key: string]: React.CSSProperties } = {
  frame: {
    width: "320px",
    height: "667px",
    border: "14px solid #222",
    borderRadius: "40px",
    overflow: "hidden", // keeps rounded corners
    backgroundColor: "#fff",
    boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
    position: "relative",
    display: "flex",
    flexDirection: "column",
  },

  //New wrapper for scrolling whole preview
  scrollableArea: {
    flex: 1,
    overflowY: "auto",
    scrollbarWidth: "none", // Firefox
    msOverflowStyle: "none", // IE/Edge
    WebkitOverflowScrolling: "touch",
  },

  // PROBLEM 3 FIXED: Attach notch to top
  notch: {
    position: "absolute",
    top: 0,
    left: "50%",
    transform: "translateX(-50%)",
    width: "200px",
    height: "15px",
    backgroundColor: "#222",
    borderBottomLeftRadius: "20px",
    borderBottomRightRadius: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "8px",
    padding: "4px 8px",
    zIndex: 3,
    boxSizing: "border-box",
  },

  speaker: {
    width: "40px",
    height: "4px",
    backgroundColor:"white",
    borderRadius: "2px",
  },

  camera: {
    width: "8px",
    height: "10px",
    backgroundColor:"white",
    borderRadius: "50%",
    boxShadow: "0 0 1px #000",
     alignSelf: "flex-end",
  },

  topArea: {
    backgroundColor: "#63555B",
    paddingTop: "36px",
    paddingBottom: "20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "relative",
    zIndex: 1,
  },

  topRow: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    paddingLeft: "20px",
  },

  hamburger: {
    fontSize: "0.95rem",
    color: "white",
  },

  logoWrapper: {
    marginBottom: "18px",
    width: "40%",
    marginLeft: "auto",
    marginRight: "auto",
  },

  appLogo: {
    width: "100%",
    height: "auto",
    objectFit: "contain",
    display: "block",
  },

  screen: {
    padding: "1rem 1.5rem 1rem 1rem",
    backgroundColor: "#fff",
    borderTopLeftRadius: "30px",
    borderTopRightRadius: "30px",
    marginTop: "-20px",
    boxSizing: "border-box",
    position: "relative",
    zIndex: 2,
  },
  closeIcon: {
    position: "absolute",
    top: "12px",
    right: "16px",
    fontSize: "1rem",
    color: "#999",
  },
  sectionBlock: {
    marginBottom: "20px", // space between sections
  },
 groupTitle: {
    fontSize: "10px",
    fontWeight: "normal",
    margin: "10px 0",
    fontFamily: "'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif",
  },
  fullWidthImage: {
    width: "100%",         // fill mobile width
    height: "102px",       // fixed height
    objectFit: "cover",    // crop to fit without distortion
    borderRadius: "12px",
    marginBottom: "8px",
  },
  twoImageRow: {
    display: "flex",
    gap: "10px",
  },
  halfImage: {
    width: "100%",         
    height: "100px",       
    objectFit: "cover", 
    borderRadius: "8px",
    marginBottom: "6px",
  },
  scrollableRow: {
    display: "flex",
    overflowX: "auto",
    gap: "10px",
    paddingBottom: "12px",
    alignItems: "flex-start",
    scrollbarWidth: "thin",
    scrollSnapType: "x mandatory",
  },
  smallImage: {
    width: "100%",
    height: "100px",
    objectFit: "cover",
    borderRadius: "8px",
    marginBottom: "6px",
  },
  moreIcon: {
    fontSize: "18px",
    color: "#999",
    alignSelf: "center",
    paddingRight: "5px",
  },
  itemImage: {
    width: "100%",
    height: "102px",
    borderRadius: "12px",
    objectFit: "cover",
    marginBottom: "1rem",
    maxWidth: "240px",
  },
   
  imageContainer: {
    width: "100%",
    height: "102px", // fixed height
    backgroundSize: "cover", // crop image to fill
    backgroundPosition: "center",
    borderRadius: "12px",
    position: "relative",
    overflow: "hidden",
  },
  imageWrapper: {
    textAlign: "center",
    flex: "1 1 50%",
  },
  descriptionText: {
    fontSize: "7px",
    color: "#666",
    lineHeight: "1.3",
    whiteSpace: "normal",
    textAlign: "left",
  },
};
